import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container"];

  remove(){
    this.containerTarget.remove();
  }
}
